import { GeneralAPI } from '../apis/GeneralAPI'
import Footer from '../components/Footer'
import Header from '../components/Header'
import HighVolumeProgramsSection from '../components/Services/HighVolumeProgramsSection'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import ManagedCampaignsSection from '../components/Services/ManagedCampaignsSection'
import MailingListsDataSection from '../components/Services/MailingListsDataSection'
import ResponseTrackingSection from '../components/Services/ResponseTrackingSection'
import ServicesClosingCta from '../components/Services/ServicesClosingCta'
import ServicesHero from '../components/Services/ServicesHero'
import ServicesJumpNav from '../components/Services/ServicesJumpNav'
import StrategyCreativeSection from '../components/Services/StrategyCreativeSection'

export default function Services({ data }) {
    return (
        <>
            <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
                <Header meta={data?.yoast_head} />
                <main>
                    <ServicesHero />
                    <ServicesJumpNav />
                    <ManagedCampaignsSection />
                    <MailingListsDataSection />
                    <StrategyCreativeSection />
                    <ResponseTrackingSection />
                    <HighVolumeProgramsSection />
                    <ServicesClosingCta />
                </main>
            </LandingPageWrapper>
            <Footer />
        </>
    )
}

export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/services')
    const data = page ? page[0] : {}

    return {
        props: {
            data,
        },
        revalidate: 10,
    }
}
